export default __webpack_public_path__ + "static/media/contact-us-classic-01.ecb60ba6.jpg";